import { render, staticRenderFns } from "./NextStepsSnippet.vue?vue&type=template&id=5cf7afd4&scoped=true&"
import script from "./NextStepsSnippet.vue?vue&type=script&lang=js&"
export * from "./NextStepsSnippet.vue?vue&type=script&lang=js&"
import style0 from "./NextStepsSnippet.vue?vue&type=style&index=0&id=5cf7afd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf7afd4",
  null
  
)

export default component.exports